var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedebate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 14.6669C26.3406 12.3206 25.2521 10.1465 23.5688 8.47959C21.8856 6.8127 19.701 5.74548 17.3515 5.44233C15.0021 5.13918 12.6181 5.6169 10.5669 6.80192C8.51569 7.98694 6.91098 9.81351 5.99998 12.0003M5.33331 6.66693V12.0003H10.6666M5.33331 17.3336C5.65939 19.68 6.74789 21.854 8.43113 23.5209C10.1144 25.1878 12.299 26.255 14.6484 26.5582C16.9979 26.8613 19.3818 26.3836 21.433 25.1986C23.4843 24.0136 25.089 22.187 26 20.0003M26.6666 25.3336V20.0003H21.3333",
    stroke: "inherit",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedebate);
export default __webpack_public_path__ + "static/media/Redebate.0990bbf49fe0b9f992105a4668b5d74f.svg";
export { ForwardRef as ReactComponent };